module.exports = __webpack_public_path__ + "img/yhhpy200_4_1.prt.8d3afd0d.jpg";